import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { translatePlain } from '@avp/core'
import { backgroundImageTypeChanged } from '../../actions/app/backgroundImageSwitcher.actions'
import { pushTrackingEvent } from '../../actions/tracking/tracking.actions'

const trackBackgroundSwitcherMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(backgroundImageTypeChanged, action)) {
        const backgroundImageType = action.payload

        const dataLayerEvent = {
            eventInfo: {
                eventAction: 'content',
                eventName: 'dcc image background switcher',
            },
            attributes: {
                componentName: 'background-image-switcher',
                label: translatePlain(`backgroundImageSwitcher.label.${backgroundImageType}`),
                currentURL: window.location.href,
                targetURL: '',
                clickID: '',
                elementName: 'drop down',
                value: backgroundImageType,
                pos: '',
            },
        }

        store.dispatch(pushTrackingEvent(dataLayerEvent))
    }
}

export default trackBackgroundSwitcherMiddleware
